import React, { FC, useMemo, Fragment } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import getConfig from "next/config";
import { getCanonical } from "helpers/url";

const { publicRuntimeConfig } = getConfig();
const CDN_URL: string = publicRuntimeConfig.CDN_URL || "";

const DOMAINS = [
  "//mc.yandex.ru",
  "//www.googletagmanager.com",
  "//state-placements.protek.ru",
  "//api.mindbox.ru",
  "//static.popmechanic.ru",
  "//www.google-analytics.com",
  "//top-fwz1.mail.ru",
  "//vk.com",
  "//cdn.diginetica.net",
  "//www.artfut.com",
  "//yastatic.net",
  "//api-maps.yandex.ru",
  CDN_URL,
].filter(Boolean);

type Props = {
  removeRegionFromCanonical?: boolean;
};

const Static: FC<Props> = ({ removeRegionFromCanonical = false }) => {
  const router = useRouter();
  const canonicalHref = useMemo(() => {
    return getCanonical(
      publicRuntimeConfig.BASE_HOST,
      router,
      removeRegionFromCanonical
    );
  }, [removeRegionFromCanonical, router]);

  return (
    <Head>
      {DOMAINS.map(item => (
        <Fragment key={item}>
          <link rel="dns-prefetch" href={item} />
          <link rel="preconnect" href={item} />
        </Fragment>
      ))}
      <link rel="canonical" href={canonicalHref} key="canonical" />

      <link
        rel="preload"
        href={`${CDN_URL}/fonts/Effra-Bold.woff2`}
        as="font"
        type="font/woff2"
        crossOrigin="true"
      />
      <link
        rel="preload"
        href={`${CDN_URL}/fonts/Effra-Regular.woff2`}
        as="font"
        type="font/woff2"
        crossOrigin="true"
      />
      <link
        rel="preload"
        href={`${CDN_URL}/fonts/Effra-Medium.woff2`}
        as="font"
        type="font/woff2"
        crossOrigin="true"
      />
      <link
        rel="preload"
        href={`${CDN_URL}/fonts/HeliosCondLightC.woff2`}
        as="font"
        type="font/woff2"
        crossOrigin="true"
      />

      <meta name="msapplication-TileColor" content="#da532c" />
      <meta
        name="msapplication-config"
        content="/img/favicons/browserconfig.xml"
      />
      <meta name="theme-color" content="#ffffff" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, user-scalable=no, viewport-fit=cover"
      />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#007FDB" />
      <meta name="apple-mobile-web-app-title" content="Здравсити" />
    </Head>
  );
};

export default React.memo(Static);
